export default "__VITE_ASSET__e3aca5dc__"